import axios from "../../util/axios";
import { ActionType } from "../../redux/actionTypes/index";
import type { Dispatch } from "redux";
import config from "../../config/config";

export function getPrograms(params: any) {
  return async function (dispatch: Dispatch) {
    try {
      await axios
        .get(`${config.defaults.api_url}/programs/all`, { params })
        .then((res: any) => {
          dispatch({
            type: ActionType.GET_ALL_PROGRAMS,
            payload: res,
          });
        });
    } catch (error) {
      dispatch({
        type: ActionType.GET_ALL_PROGRAMS_FAILED,
        payload: {
          message: "Unable to get programs",
        },
      });
    }
  };
}
